(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["im-pyramid-scene"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('im-pyramid-scene')) {
  customElements.define('im-pyramid-scene', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('button');
      this.stones = [...this.querySelectorAll('[data-build-stone]')].map((node, index) => ({node, index, x: +node.dataset.x, y: +node.dataset.y, row: +node.dataset.row, cap: node.hasAttribute('data-capstone')}));
      this.teams = [...this.querySelectorAll('[data-builder-team]')].map(node => ({node, stone: node.querySelector('[data-carried-stone]'), block: node.querySelector('[data-carried-block]'), cap: node.querySelector('[data-carried-cap]'), legs: [...node.querySelectorAll('[data-worker-leg]')], backLegs: [...node.querySelectorAll('[data-worker-leg-back]')]}));
      this.ramp = this.querySelector('[data-ramp]');
      this.rampFace = this.querySelector('[data-ramp-face]');
      this.rampTop = this.querySelector('[data-ramp-top]');
      this.platform = this.querySelector('[data-platform]');
      this.construction = this.querySelector('[data-construction]');
      this.laidStones = this.querySelector('[data-laid-stones]');
      this.finishedPyramid = this.querySelector('[data-finished-pyramid]');
      this.mason = this.querySelector('[data-mason-arm]');
      this.interval = 320;
      this.travel = 1050;
      this.completeAt = (this.stones.length - 1) * this.interval + this.travel;
      this.finishDuration = 650;
      this.cycle = this.completeAt + 4000;
      this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motionPreference.matches;
      this.clock = this.paused ? this.completeAt + this.finishDuration + 100 : 0;
      this.inView = true;
      this.button.hidden = false;
      this.onToggle = () => {
        this.paused = !this.paused;
        this.updateMotion();
      };
      this.onPreference = () => {
        this.paused = this.motionPreference.matches;
        this.updateMotion();
      };
      this.onVisibility = () => this.updateMotion();
      this.button.addEventListener('click', this.onToggle);
      this.motionPreference.addEventListener('change', this.onPreference);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updateMotion();
      });
      this.observer.observe(this);
      this.renderFrame();
      this.updateMotion();
    }
    renderFrame() {
      const t = this.clock % this.cycle;
      const finish = Math.max(0, Math.min(1, (t - this.completeAt) / this.finishDuration));
      const finishEase = finish * finish * (3 - 2 * finish);
      this.finishedPyramid.setAttribute('opacity', String(finishEase));
      this.laidStones.setAttribute('opacity', String(1 - finishEase));
      this.dataset.finished = String(finish === 1);
      let count = 0;
      this.teams.forEach(team => team.node.setAttribute('opacity', '0'));
      let rampStone = null;
      for (const stone of this.stones) {
        const start = stone.index * this.interval;
        const end = start + this.travel;
        const laid = t >= end;
        stone.node.setAttribute('opacity', laid ? '1' : '0');
        if (laid) count++;
        if (t < start || t >= end) continue;
        rampStone = stone;
        const progress = (t - start) / this.travel;
        const right = 588 - Math.min(stone.row, 6) * 25;
        const entryX = right + 24;
        const levelY = stone.y + 28;
        let x, y;
        if (progress < .65) {
          const u = progress / .65;
          x = 776 + (entryX - 776) * u;
          y = 313 + (levelY - 313) * u;
        } else {
          const u = Math.min(1, (progress - .65) / .24);
          x = entryX + (stone.x - entryX) * u;
          y = levelY;
        }
        const team = this.teams[stone.index % this.teams.length];
        const lift = Math.max(0, Math.min(1, (progress - .89) / .11));
        team.node.setAttribute('opacity', String(Math.min(1, progress * 20)));
        team.node.setAttribute('transform', `translate(${x.toFixed(2)} ${y.toFixed(2)})`);
        team.stone.setAttribute('transform', `translate(0 ${-22 - lift * 6})`);
        team.block.setAttribute('opacity', stone.cap ? '0' : '1');
        team.cap.setAttribute('opacity', stone.cap ? '1' : '0');
        const stride = progress < .89 ? Math.sin(t / 55 + stone.index) * 21 : 0;
        team.legs.forEach(leg => leg.style.transform = `rotate(${stride}deg)`);
        team.backLegs.forEach(leg => leg.style.transform = `rotate(${-stride}deg)`);
      }
      this.ramp.setAttribute('opacity', rampStone ? '.8' : '0');
      if (rampStone) {
        const row = Math.min(rampStone.row, 6);
        const right = 612 - row * 25;
        const y = rampStone.y + 28;
        const left = 218 + row * 25;
        this.rampFace.setAttribute('d', `M${right} ${y}L800 323V329L${right} ${y + 6}Z`);
        this.rampTop.setAttribute('d', `M${right} ${y}L800 323L812 317L${right + 12} ${y - 6}Z`);
        this.platform.setAttribute('d', `M${left} ${y}H${right}`);
      }
      const fade = t > this.cycle - 350 ? (this.cycle - t) / 350 : 1;
      this.construction.setAttribute('opacity', String(fade));
      this.mason.setAttribute('transform', `rotate(${Math.sin(t / 85) * 24} -2 -31)`);
      this.dataset.builtCount = String(count);
    }
    updateMotion() {
      const stopped = this.paused || !this.inView || document.hidden;
      this.dataset.userPaused = String(this.paused);
      this.dataset.paused = String(stopped);
      this.button.setAttribute('aria-pressed', String(this.paused));
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
      if (!stopped) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (this.dataset.paused === 'true') return;
      if (this.lastTime !== null) this.clock += Math.min(time - this.lastTime, 100);
      this.lastTime = time;
      this.renderFrame();
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
      this.motionPreference?.removeEventListener('change', this.onPreference);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
